
import api from "@/api";

const namespaced = true;

const state = {
  bargeMonitoring: {}
}

const getters = {
  bargeMonitoring: state => state.bargeMonitoring
}

const mutations = {
  SET_BARGE_MONITORING: (state, payload) => {
    state.bargeMonitoring = payload;
  }
}

const actions = {
  async fetchBargeMonitoring({ commit }, payload) {
    try {
      const { data } = await api.getBargeMonitoringKpi(payload)

      if (data.error) {
        commit('SET_BARGE_MONITORING', null)
        return
      }

      commit('SET_BARGE_MONITORING', data)
    } catch (error) {
      throw error;
    }
  }
}

export default { namespaced, state, getters, mutations, actions }